export const DATE_FORMAT = 'dd.MM.yy';
export const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export const TOKEN_KEY = 'token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const IS_LOGGED_IN_KEY = 'is_logged_in';
